import { render, staticRenderFns } from "./adminMec.vue?vue&type=template&id=5fb066a5&scoped=true&"
import script from "./adminMec.vue?vue&type=script&lang=js&"
export * from "./adminMec.vue?vue&type=script&lang=js&"
import style0 from "./adminMec.vue?vue&type=style&index=0&id=5fb066a5&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fb066a5",
  null
  
)

export default component.exports